import styled from 'styled-components';

export const QOBLogo = styled.img`
  max-width: 100%;

  @media only screen and (min-width: 768px) {
    margin-top: 2rem;
  }
`;

export const FormWrapper = styled.div`
  #username {
    background-color: rgba(0, 0, 0, 0.9);
  }

  #password {
    background-color: rgba(0, 0, 0, 0.9);
  }
`;

export const LogoGIF = styled.img`
  position: absolute;
  width: 170vw;
  max-width: 772px;
`;

export const LogoQFBAnim = styled.img`
  position: absolute;
  width: 85vw;
  max-width: 372px;
`;

export const AnimWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100vw;
  height: 100vh;
`;

export const ContainerWrapper = styled.div`
  .anim-in {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    width: 100vw;
    height: 100vh;
    padding: 0;
  }

  .anim-end {
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-flow: column;
    width: calc(100vw - 2em);
    height: calc(100vh - 1em);

    @media only screen and (min-width: 768px) {
      width: calc(100vw - 4em);
      height: calc(100vh - 2em);
      padding: 0;
    }
  }
`;
